<template>
  <div class="page-container ">
    <el-card>
      <div>
        操作: <el-button type="primary" @click="dia()">导入主播</el-button>
      </div>
      <div class="user-options box">
        <div>预警主播</div>
        <div>
          <span id="a1">{{ total }}</span> 人
        </div>
        <div @click="xq()">详情 ></div>
      </div>
      <!-- 时间范围天 -->
      <div>
        <div class="user-options">
          时间范围 (天) :
          <el-date-picker
            :picker-options="retainedOptions"
            value-format="yyyy-MM-dd"
            v-model="platformData"
            type="date"
            style="width:150px"
            placeholder="选择日期"
          >
          </el-date-picker>
          预警值:
          <el-select
            style="width:150px"
            v-model="judgeValue"
            placeholder="请选择"
          >
            <el-option
              v-for="item in judgeValues"
              :key="item.value"
              :label="item.value"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button :loading="login1" @click="monitor_list()" type="primary"
            >搜索</el-button
          >
        </div>
        <div>
          <Panel
            :texxt="texxt[0]"
            :platformData="platformData"
            :onlineTimeVO="tableList1"
            v-loading="login1"
          ></Panel>
        </div>
      </div>
      <!-- 时间范围周 -->
      <div>
        <div class="user-options">
          时间范围 (周) :
          <el-date-picker
            :picker-options="retainedOptions_1"
            :clearable="false"
            value-format="yyyy-MM-dd"
            format="yyyy 第 WW 周"
            v-model="platformData1"
            type="week"
            style="width:150px"
            placeholder="选择周"
            @change="changeweek"
          >
          </el-date-picker>
          预警值:
          <el-select
            style="width:150px"
            v-model="judgeValue1"
            placeholder="请选择"
          >
            <el-option
              v-for="item in judgeValues"
              :key="item.value"
              :label="item.value"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button :loading="login2" @click="monitor_list_()" type="primary"
            >搜索</el-button
          >
        </div>
        <div>
          <Panel
            :texxt="texxt[1]"
            :platformData="weekTime"
            :onlineTimeVO="tableList2"
            v-loading="login2"
          ></Panel>
        </div>
      </div>
      <!-- 时间范围月 -->
      <div>
        <div class="user-options">
          时间范围 (月) :
          <el-date-picker
            :picker-options="retainedOptions_"
            value-format="yyyy-MM-dd"
            v-model="platformData2"
            type="month"
            style="width:150px"
            @change="changeMonth"
            placeholder="选择日期"
          >
          </el-date-picker>
          预警值:
          <el-select
            style="width:150px"
            v-model="judgeValue2"
            placeholder="请选择"
          >
            <el-option
              v-for="item in judgeValues"
              :key="item.value"
              :label="item.value"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button :loading="login3" @click="monitor_list_1()" type="primary"
            >搜索</el-button
          >
        </div>
        <div>
          <Panel
            :texxt="texxt[2]"
            :platformData="weekTime_"
            :onlineTimeVO="tableList3"
            v-loading="login3"
          ></Panel>
        </div>
      </div>
    </el-card>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div>
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入主播id, 用英文 , 隔开"
          v-model="ridStr"
        >
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="batch()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogVisible1"
      width="900px"
      :before-close="handleClose"
    >
      <div class="user-options">
        主播ID:
        <el-input style="width:120px" placeholder="请输入主播id" v-model="rid">
        </el-input>
        <!-- valid:
        <el-select style="width:120px" v-model="valid" placeholder="请选择">
          <el-option
            v-for="item in valids"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
        <el-button @click="get_list" :loading="login" type="primary"
          >搜索</el-button
        >
      </div>
      <div class="user-options">主播人数:{{ total }}人</div>
      <div>
        <el-table
          height="60vh"
          v-loading="login"
          :data="tableList"
          style="width: 100%;font-size: 13px;"
        >
          <el-table-column prop="rid" label="主播id" align="center">
          </el-table-column>
          <el-table-column prop="founder" label="创建人" align="center">
          </el-table-column>
          <el-table-column prop="name" label="名字" align="center">
          </el-table-column>
          <el-table-column prop="operator" align="center" label="操作人">
          </el-table-column>
          <el-table-column prop="valid" align="center" label="是否有效">
            <template slot-scope="scope">
              {{ scope.row.valid == 1 ? '有效' : '无效' }}
            </template>
          </el-table-column>
          <el-table-column prop="ctimeStr" align="center" label="创建时间">
          </el-table-column>
          <el-table-column prop="mtimeStr" align="center" label="修改时间">
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <div class="dele" @click="del(scope.row.id)">删除</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-row>
        <el-pagination
          :current-page.sync="page"
          layout="total, prev, pager, next"
          background
          @current-change="handleCurrentChange"
          :total="total"
          :page-size="30"
        ></el-pagination>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import Panel from '@/components/Panel'
import { datainfor } from '@/utils/formdata.js'
export default {
  components: {
    Panel
  },
  data () {
    return {
      texxt: ['较昨日', '较上周', '较上月'],
      login: false,
      login1: false,
      login2: false,
      login3: false,
      dialogVisible: false,
      dialogVisible1: false,
      ridStr: '',
      rid: '',
      valid: 1,
      valids: [
        {
          value: 1,
          label: '有效'
        },
        {
          value: 0,
          label: '无效'
        }
      ],
      platformData: datainfor(1),
      platformData1: datainfor(8),
      platformData2: datainfor(30),
      weekTime: [],
      weekTime_: [],
      retainedOptions: {
        disabledDate (time) {
          return time.getTime() > new Date().valueOf() - 1 * 86400000
        },
        firstDayOfWeek: 1
      },
      retainedOptions_1: {
        disabledDate (time) {
          let todayDay = new Date()
          let spendDay = 1
          let todayOfWeek = todayDay.getDay()
          if (todayOfWeek !== 0) {
            spendDay = 7 - todayOfWeek // 开始时间到结束时间还有几天
          }
          let startTimeNum = todayDay.valueOf() - (7 - spendDay) * 86400000
          return time.getTime() > startTimeNum
        },
        firstDayOfWeek: 1
      },
      retainedOptions_: {
        disabledDate (time) {
          let a = new Date().getMonth() - 1
          if (a == 0) {
            a = 12
          }
          return time.getMonth() > new Date().getMonth() - 1
        },
        firstDayOfWeek: 1
      },
      judgeValue: 5,
      judgeValue1: 5,
      judgeValue2: 5,
      judgeValues: [
        {
          value: 5
        },
        {
          value: 10
        },
        {
          value: 20
        }
      ],
      page: 1,
      total: 0,
      tableList: [],
      tableList1: [],
      tableList2: [],
      tableList3: []
    }
  },
  beforeCreate () {},
  created () {
    this.changeweek(this.platformData1)
    this.changeMonth(this.platformData2)
    this.get_list()
    this.monitor_list()
    this.monitor_list_()
    this.monitor_list_1()
  },
  mounted () {},
  computed: {},
  watch: {},
  methods: {
    handleCurrentChange (num) {
      this.page = num
      this.get_list()
    },
    dia () {
      this.dialogVisible = true
      this.ridStr = ''
      this.get_list()
    },
    addNumber (start, end, id) {
      let o = document.getElementById(id)
      let i = start
      let Interval
      if (i < end) {
        Interval = setInterval(function () {
          i += 50 // 设置每次增加的动态数字，可调整
          if (i > end) {
            clearInterval(Interval) // 清除setInterval的time，这个方法w3c可具体查看文档
            o.innerHTML = end.toLocaleString() // 此赋值是为了避免最后一次增加过后的数据和真实数据不同
            i = 0
          } else {
            o.innerHTML = i.toLocaleString()
          }
        }, 10) // 数据跳转的速度控制
      }
    },
    // 被监控主播列表
    async get_list () {
      this.login = true
      const { data: res } = await this.$axios({
        method: 'get',
        url:
          this.$store.getters.path.monitor_list +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        withCredentials: true,
        params: {
          rid: this.rid,
          valid: this.valid,
          page: this.page
        }
      })
      if (res.code != 0) return this.$message.error(res.msg)
      this.login = false
      this.tableList = res.data.data
      this.total = res.data.total
      this.addNumber(0, this.total, 'a1')
    },
    // 批量插入主播
    async batch () {
      this.login1 = true
      const { data: res } = await this.$axios({
        method: 'post',
        url:
          this.$store.getters.path.create_batch +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        withCredentials: true,
        data: {
          ridStr: this.ridStr
        }
      })
      if (res.code != 0) return this.$message.error(res.msg)
      this.login1 = false
      this.$message.success(JSON.stringify(res.data))
      this.dialogVisible = false
    },
    // 移出监控主播列表
    del (id) {
      this.$confirm('确认删除？')
        .then(async () => {
          const { data: res } = await this.$axios({
            method: 'get',
            url:
              this.$store.getters.path.monitor_del +
              '?username=' +
              this.$store.getters.username +
              '&token=' +
              this.$store.getters.token,
            withCredentials: true,
            params: {
              id: id
            }
          })
          if (res.code != 0) return
          this.get_list()
        })
        .catch(() => {})
    },
    // 面板数据
    async monitor_list () {
      this.login1 = true
      const { data: res } = await this.$axios({
        method: 'get',
        url:
          this.$store.getters.path.monitor_panel +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        withCredentials: true,
        params: {
          start: this.platformData,
          end: this.platformData,
          judgeValue: this.judgeValue
        }
      })
      if (res.code != 0) return
      this.login1 = false
      this.tableList1 = [
        res.data.onlineTimeVO,
        res.data.incomeVO,
        res.data.guaranteedIncomeVO,
        res.data.flowIncomeVO
      ]
    },
    async monitor_list_ () {
      this.login2 = true
      const { data: res } = await this.$axios({
        method: 'get',
        url:
          this.$store.getters.path.monitor_panel +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        withCredentials: true,
        params: {
          start: this.weekTime[0],
          end: this.weekTime[1],
          judgeValue: this.judgeValue1
        }
      })
      if (res.code != 0) return
      this.login2 = false
      this.tableList2 = [
        res.data.onlineTimeVO,
        res.data.incomeVO,
        res.data.guaranteedIncomeVO,
        res.data.flowIncomeVO
      ]
    },
    async monitor_list_1 () {
      this.login3 = true
      const { data: res } = await this.$axios({
        method: 'get',
        url:
          this.$store.getters.path.monitor_panel +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        withCredentials: true,
        params: {
          start: this.weekTime_[0],
          end: this.weekTime_[1],
          judgeValue: this.judgeValue2
        }
      })
      if (res.code != 0) return
      this.login3 = false
      this.tableList3 = [
        res.data.onlineTimeVO,
        res.data.incomeVO,
        res.data.guaranteedIncomeVO,
        res.data.flowIncomeVO
      ]
    },
    handleClose () {
      this.$confirm('确认关闭？')
        .then(() => {
          this.dialogVisible = false
          this.dialogVisible1 = false
        })
        .catch(() => {})
    },
    xq () {
      this.dialogVisible1 = true
      this.valid = 1
      this.rid = ''
    },
    changeweek (val) {
      let todayDay = val ? new Date(val) : new Date()
      let todayOfWeek = todayDay.getDay()
      // let todayOfmonth = todayDay.getMonth()
      // let todayOfDate = todayDay.getDate()
      let spendDay = 1
      if (todayOfWeek !== 0) {
        spendDay = 7 - todayOfWeek // 开始时间到结束时间还有几天
      }
      //  86400000为一天的毫秒数
      let startTimeNum = todayDay.valueOf() - (6 - spendDay) * 86400000 // 开始时间时间戳
      let endTimeNum = todayDay.valueOf() + spendDay * 86400000 // 结束时间时间戳
      let startTimeStr = this.timestampToTime(startTimeNum) // 时间戳转字符串
      let endTimeStr = this.timestampToTime(endTimeNum)
      this.weekTime = [startTimeStr, endTimeStr] // 选择的范围
    },
    changeMonth (value) {
      let date = new Date(value)
      let month = (date.getMonth() + 1).toString().padStart(2, '0')
      let year = date.getFullYear()
      let startTime = year + '-' + month + '-01'
      let day = new Date(year, month, 0)
      let endTime = year + '-' + month + '-' + day.getDate()
      this.weekTime_ = [startTime, endTime]
    },
    timestampToTime (timestamp) {
      var date = new Date(timestamp) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + '-'
      let M =
        (date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1) + '-'
      let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      return Y + M + D
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  margin-left: 20px;
  margin-top: 20px;
  h1 {
    font-size: 28px;
    font-weight: bold;
  }
}

.user-options {
  margin-top: 30px;

  button {
    margin-left: 30px;
  }
}

.box {
  height: 100px;
  border: 1px solid #909399;
  border-radius: 8px;
  padding: 10px 30px 0;
  > div {
    margin: 0 0 15px;
    display: flex;
    align-items: center;
    > span {
      font-size: 25px;
      margin: 0 10px;
    }
  }
  > :nth-child(3) {
    padding: 0 30px;
    cursor: pointer;
    font-size: 13px;
  }
}

.dele {
  cursor: pointer;
  color: red;
}
</style>
